import React, { Component } from 'react';

import ReactDOM from 'react-dom';

import FroalaEditor from 'react-froala-wysiwyg';
import Froala from 'froala-editor';

// Core JS/CSS
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';

// Language
import 'froala-editor/js/languages/pt_br';

// Plugins bundle + specific plugin
import 'froala-editor/js/plugins.pkgd.min';
import 'froala-editor/js/plugins/import_from_word.min';
import 'froala-editor/js/plugins/export_to_word.min';

// Mammoth (client-side conversion dependency)
import * as mammoth from 'mammoth/mammoth.browser';

import '../assets/libs/font-awesome/css/font-awesome.css';
import Button from 'react-bootstrap/Button';
import SweetAlert from 'react-bootstrap-sweetalert/lib/dist/SweetAlert';
import intl from 'react-intl-universal';

import Axios from 'axios';
import fLoading from '../assets/img/preloader-black.gif';
import fGpt from '../assets/img/chatGpt.png';
import EncodedLocalStorage from '../config/EncodedLocalStorage';
import { Alert } from '../components/Alert';
import url from '../config/Url';
import {
  fnConvertLegacyWordDocToDocx,
  fnGetWordImportConversionErrorKey,
  fnIsLegacyWordDoc,
} from '../services/wordImport';

import { saveAs } from "file-saver";
import htmlDocx from "html-docx-js/dist/html-docx";



if (typeof window !== 'undefined') {
  window.mammoth = mammoth?.default ?? mammoth;
  window.saveAs = saveAs;
  window.htmlDocx = htmlDocx?.default ?? htmlDocx;
}

const oLocalStorage = new EncodedLocalStorage();

export default class FroalaEditorComponent extends Component {
  constructor(oProps) {
    oLocalStorage.decodeToken();

    localStorage.setItem('cApiGpt', oLocalStorage.get('cApiGpt') || '0');

    super(oProps);
    this.state = {
      model: oProps.model,
      alertMessage: '',
      isLoading: false,
      bHasGptKey: oLocalStorage.get('cApiGpt') === '1' || localStorage.getItem('cApiGpt') === '1',
      cErrorModalMsg: '',
      isImportingWordImages: false,
      isConvertingWordDocument: false,
      importTotal: 0,
      importDone: 0,
      importError: 0,
    };

    this.bIsMounted = true;
    this.bWordConversionInProgress = false;
    this.editorRef = null;

    this.hideAlert = this.hideAlert.bind(this);
    this.config = { ...oProps.config };
  }

  saveApiKey = (cNewApiKey) => {
    this.setState({ alertMessage: '' });
  }

  startWordImageImportProgress = (total) => {
    if (!this.bIsMounted) return;
    this.setState({
      isImportingWordImages: true,
      importTotal: total || 0,
      importDone: 0,
      importError: 0,
    });
  };

  finishWordImageImportProgress = () => {
    if (!this.bIsMounted) return;
    this.setState({
      isImportingWordImages: false,
    });
  };

  bumpWordImageImportDone = (ok = true) => {
    if (!this.bIsMounted) return;
    this.setState(prev => ({
      importDone: prev.importDone + 1,
      importError: ok ? prev.importError : (prev.importError + 1),
    }));
  };

  dataUrlToFile = async (dataUrl, filename = "image.png") => {
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    const ext = blob.type?.split("/")[1] || "png";
    return new File([blob], filename.replace(/\.\w+$/, `.${ext}`), { type: blob.type });
  };

  uploadImageFile = async (editor, file) => {
    const form = new FormData();

    // nome do field que o Froala espera (default: "file")
    const fieldName = editor?.opts?.imageUploadParam || "file";
    form.append(fieldName, file);

    // url do upload (você PRECISA ter isso configurado no Froala)
    const uploadUrl = editor?.opts?.imageUploadURL;
    if (!uploadUrl) throw new Error("imageUploadURL não definido no config do Froala.");

    // params extras se você usa (ex.: custId etc)
    const params = editor?.opts?.imageUploadParams || {};
    Object.keys(params).forEach(k => form.append(k, params[k]));

    const resp = await Axios.post(uploadUrl, form, {
      headers: {
        "Content-Type": "multipart/form-data",

        // se você já usa token no Froala, pode pegar daqui também:
        ...(editor?.opts?.requestHeaders || {}),

        // se não usa requestHeaders no Froala, mantém o seu padrão:
        Authorization: `Bearer ${localStorage.getItem("cAccessToken")}`,
        nCustId: sessionStorage.getItem("nCustId") || localStorage.getItem("nCustId"),
        Accept: "application/json",
      },
    });

    // Froala geralmente retorna { link: "..." }
    const link = resp?.data?.link || resp?.data?.url;
    if (!link) throw new Error("Resposta do upload não retornou 'link' nem 'url'.");

    return link;
  };


  replaceBase64ImagesWithUploadedUrls = async (editor, html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const imgs = Array.from(doc.querySelectorAll("img"))
      .filter(img => (img.getAttribute("src") || "").startsWith("data:image/"));

    // ✅ começa progresso
    this.startWordImageImportProgress(imgs.length);
    await new Promise(requestAnimationFrame);


    try {
      for (let i = 0; i < imgs.length; i++) {
        const img = imgs[i];
        const src = img.getAttribute("src");

        try {
          const file = await this.dataUrlToFile(src, `imported_${Date.now()}_${i}.png`);
          const urlUploaded = await this.uploadImageFile(editor, file);
          img.setAttribute("src", urlUploaded);

          this.bumpWordImageImportDone(true);
        } catch (e) {
          console.warn("Falha ao subir imagem importada:", e);
          this.bumpWordImageImportDone(false);
        }
      }

      return doc.body.innerHTML;
    } finally {
      this.finishWordImageImportProgress();
    }
  };


  componentDidMount() {
    oLocalStorage.decodeToken();
    const cLanguage = oLocalStorage.get('cLanguage') ? oLocalStorage.get('cLanguage') : 'pt';
    window.mammoth = mammoth?.default ?? mammoth;

    let pt = Froala.LANGUAGE.pt_br.translation;
    pt['Type something'] = intl.get('DocumentEditor.type_something');
    pt['Image'] = intl.get('imagem');
    pt['Insert Image'] = intl.get('DocumentEditor.insert_image');

    this.addEventListeners();

    Froala.DefineIconTemplate('copilot_gpt', '<img src=[SRC] alt=[ALT] style="width: 90px;height: 28px;margin-top: auto;margin-bottom: auto;border-radius: 5px;"/>');
    Froala.DefineIcon('imageIcon', { SRC: fGpt, ALT: 'Copilot GPT', template: 'copilot_gpt' });
    Froala.RegisterCommand("chatGPT", {
      title: "Copilot GPT",
      icon: 'imageIcon',
      undo: false,
      focus: false,
      plugin: 'save',
      callback: () => {
        if (!this.bIsMounted) return;

        const cSelection = this.getSelectedText();
        if (cSelection) {
          const bHasGptKey = this.state.bHasGptKey || localStorage.getItem('cApiGpt') === '1' || oLocalStorage.get('cApiGpt') === '1';
          if (bHasGptKey) {
            this.callGptAPI(cSelection);
          } else {
            this.setState({
              alertMessage: intl.get('ChatGpt.configurar_api')
            });
          }
        } else {
          this.setState({
            alertMessage: intl.get('ChatGpt.selecionar_texto')
          });
        }
      }
    });
  }

  addEventListeners = () => {
    try {
      if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('scroll', this.recalculateFroalaPosition);
        window.addEventListener('resize', this.recalculateFroalaPosition);
      }
    } catch (error) {
      console.warn('Erro ao adicionar event listeners:', error);
    }
  }

  recalculateFroalaPosition = () => {
    if (!this.bIsMounted) return;

    try {
      const elPopup = document.querySelector('.fr-popup.fr-desktop.fr-active');
      if (elPopup) {
        elPopup.style.zIndex = '2147483647';
      }
    } catch (error) {
      console.warn('Erro ao recalcular posição do Froala:', error);
    }
  };

  componentWillUnmount() {
    this.bIsMounted = false;
    this.removeEventListeners();
    this.editorRef = null;
  }

  removeEventListeners = () => {
    try {
      if (typeof window !== 'undefined' && window.removeEventListener) {
        window.removeEventListener('scroll', this.recalculateFroalaPosition);
        window.removeEventListener('resize', this.recalculateFroalaPosition);
      }
    } catch (error) {
      console.warn('Erro ao remover event listeners:', error);
    }
  }

  getSelectedText = () => {
    try {
      if (this.editorRef && this.editorRef.getEditor) {
        const editorInstance = this.editorRef.getEditor();
        if (editorInstance && editorInstance.selection) {
          return editorInstance.selection.text();
        }
      }
      return '';
    } catch (error) {
      console.warn('Erro ao obter texto selecionado:', error);
      return '';
    }
  }

  callGptAPI = (cSelection) => {
    if (!this.bIsMounted) return;

    this.setState({ isLoading: true });

    Axios.patch("/customer/handle-gpt-request", {
      selection: cSelection
    }, {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${localStorage.getItem('cStorageToken')}`,
        'nCustId': sessionStorage.getItem('nCustId') || localStorage.getItem('nCustId'),
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (!this.bIsMounted) return;

      this.setState({ isLoading: false });
      const data = response.data;

      if (data.cResult && this.editorRef && this.editorRef.getEditor) {
        const editorInstance = this.editorRef.getEditor();
        if (editorInstance && editorInstance.html) {
          const responses = data.cResult.join('<br><br>');
          editorInstance.html.insert(cSelection + '<br>' + responses);
        }
      }
    })
    .catch(error => {
      if (!this.bIsMounted) return;

      console.error('Erro ao solicitar resposta do ChatGPT:', error);
      this.setState({ isLoading: false });

      if (this.editorRef && this.editorRef.getEditor) {
        const editorInstance = this.editorRef.getEditor();
        if (editorInstance && editorInstance.html) {
          if (error.response && error.response.data && error.response.data.cError) {
            const errorMessage = error.response.data.cError;
            const errorDetail = error.response.data.cDetails;
            editorInstance.html.insert(`<p><strong>Error:</strong> ${errorMessage}</p><br>`);
            if (errorDetail) editorInstance.html.insert(`<p> ${errorDetail}</p>`);
          } else {
            editorInstance.html.insert('<p><strong>Error:</strong> Falha na comunicação com o ChatGPT. Por favor, tente novamente mais tarde.</p>');
          }
        }
      }
    });
  }

  handleModelChange(cModel) {
    if (!this.bIsMounted) return;

    this.setState({
      model: cModel
    });
  }

  /**
   * Recebe o editor Froala e o arquivo .doc original do evento sincrono.
   * Apos converter, reutiliza o importador nativo para preservar o tratamento
   * existente de HTML, imagens e onModelChange.
   */
  handleLegacyWordImport = async (oEditor, oFile) => {
    if (this.bWordConversionInProgress) return;

    this.bWordConversionInProgress = true;
    if (this.bIsMounted) this.setState({ isConvertingWordDocument: true });

    try {
      const oDocxFile = await fnConvertLegacyWordDocToDocx(oFile);
      if (typeof oEditor?.importFromWord?.import !== 'function') {
        throw new Error('Importador Word do editor indisponivel.');
      }

      oEditor.importFromWord.import(oDocxFile);
    } catch (oError) {
      console.error('Erro ao converter .doc para importacao no Froala:', oError);
      if (this.bIsMounted) {
        this.setState({
          cErrorModalMsg: intl.get(`DocumentEditor.${fnGetWordImportConversionErrorKey(oError)}`),
        });
      }
    } finally {
      this.bWordConversionInProgress = false;
      if (this.bIsMounted) this.setState({ isConvertingWordDocument: false });
    }
  };

  hideAlert = () => {
    if (!this.bIsMounted) return;

    this.setState({
      cErrorModalMsg: '',
      alertMessage: '',
    });
  };



  render() {
    const { fnHandleChange, bSimpleEditor, cTypeComment, bReadOnly, bRevisor } = this.props;
    const { alertMessage, model, isLoading, bHasGptKey, cErrorModalMsg, isImportingWordImages, isConvertingWordDocument, importTotal, importDone, importError } = this.state;

    // clona o config base para não sujar this.config entre renders
    const config = { ...this.config };

    // =========================
    // Config global (sempre)
    // =========================
    config.toolbarSticky = true;
    config.toolbarStickyOffset = 20;
    config.heightMin = 300;
    config.heightMax = 800;
    config.language = "pt_br";
    config.fontSizeUnit = "pt";
    config.attribution = false;
    config.documentReady = true;
    config.charCounterCount = false;
    config.toolbarInline = false;

    config.videoAllowedAttributes = [
      "src", "width", "height", "controls", "poster", "source", "type",
      "style", "class", "name", "id"
    ];
    config.videoAllowedTypes = ["mp4"];
    config.videoUploadMethod = "POST";
    config.videoMaxSize = 80 * 1024 * 1024;
    config.tabSpaces = 4;

    // === Import from Word (Froala v5) ===
    config.importFromWordMaxFileSize = 10 * 1024 * 1024; // 10MB
    config.importFromWordFileTypesAllowed = ["docx", "doc"];
    config.importFromWordEnableImportOnDrop = true;

    config.wordExportFileName = "Documento";


    // Endpoint do SEU backend que recebe o arquivo e devolve HTML (se usar)
    // config.importFromWordUrlToUpload = `${url.cBase}/froala/import-word`;

    config.pasteIgnoreFormatting = false;
    config.pastePlain = false;
    config.pasteAllowedStyleProps = [
      "font-style", "font-weight", "text-decoration", "text-align",
      "color", "background-color", "font-size"
    ];

    // ✅ garante que não estão desativados por config externo
    const forceEnable = ["importFromWord", "exportToWord"];

    if (Array.isArray(config.pluginsDisabled)) {
      config.pluginsDisabled = config.pluginsDisabled.filter(p => !forceEnable.includes(p));
    }

    if (Array.isArray(config.pluginsEnabled)) {
      // mantém o que já existe e adiciona os 2 se faltarem
      forceEnable.forEach(p => {
        if (!config.pluginsEnabled.includes(p)) config.pluginsEnabled.push(p);
      });
    }

    // =========================
    // Eventos
    // =========================
    const self = this;

    config.events = {
      initialized: function () {
        try {
          const editor = this;
          const editorEl = editor?.el;
          editor.opts._reactComponent = self;
          if (editor?.opts?.toolbarSticky && editor?.toolbar) {
            editor.toolbar.show();
          }

          // Atalho Ctrl+Shift+I => Import
          editor.el.addEventListener("keydown", (e) => {
            if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") {
              e.preventDefault();
              editor.commands.exec("import_from_word");
            }
          });

          // Atalho Ctrl+Shift+E => Export
          editor.el.addEventListener("keydown", (e) => {
            if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "e") {
              e.preventDefault();
              editor.commands.exec("export_to_word");
            }
          });

          // ReadOnly
          if (bReadOnly && editor?.edit && typeof editor.edit.off === "function") {
            editor.edit.off();
          }

          // Links clicáveis
          if ((bReadOnly || bRevisor) && editorEl && !editorEl.dataset.linksClickablePatched) {
            editorEl.dataset.linksClickablePatched = "1";
            editorEl.setAttribute('contenteditable', 'false');

            editorEl.addEventListener(
              "click",
              (evt) => {
                const a = evt.target.closest("a");
                if (a?.href) {
                  evt.preventDefault();
                  evt.stopPropagation();
                  window.open(a.href, "_blank");
                }
              },
              true
            );
          }

        } catch (error) {
          console.warn("Erro ao inicializar Froala:", error);
        }
      },
      contentChanged: function () {
        try {
          setTimeout(() => {
            if (typeof window !== "undefined" && window.dispatchEvent) {
              window.dispatchEvent(new Event("resize"));
            }
          }, 100);
        } catch (error) {
          console.warn("Erro no evento contentChanged:", error);
        }
      },

      "video.error": (evtVidErr) => {
        if (this.bIsMounted && evtVidErr && evtVidErr.code === 5) {
          this.setState({ cErrorModalMsg: intl.get("DocumentEditor.erro_upload_video_dimensoes") });
        }
      },

      "paste.beforeCleanup": function (clipboardHtml) {
        try {
          if (!clipboardHtml || typeof clipboardHtml !== "string") return clipboardHtml;

          clipboardHtml = clipboardHtml
            .replace(/<div[^>]*?style="[^"]*?height:\s*\d+\.?\d*px;?[^"]*?"[^>]*?>/g, match => match.replace(/height:\s*\d+\.?\d*px;?/g, ""))
            .replace(/<\/?h[1-6][^>]*>/g, match => (match.startsWith("</") ? "</p>" : "<p>"))
            .replace(/:\s*[^;]*var\(--[^)]+\)[^;]*;/g, match => match.replace(/var\(--[^)]+\)/g, "").trim())
            .replace(/<[^>]*?style="[^"]*?white-space:\s*pre;?[^"]*?"[^>]*?>/g, match => match.replace(/white-space:\s*pre;?/g, "").trim())
            .replace(/class="?Mso[a-zA-Z0-9]*"?/g, "")
            .replace(/style="[^"]*mso-[^"]*"/g, "")
            .replace(/<o:p>\s*<\/o:p>/g, "")
            .replace(/<o:p>.*?<\/o:p>/g, "&nbsp;")
            .replace(/<!--\[if [^\]]+\]>.*?<!\[endif\]-->/g, "")
            .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");

          return clipboardHtml;
        } catch (error) {
          console.warn("Erro no paste.beforeCleanup:", error);
          return clipboardHtml;
        }
      },
      'word.beforeImport': function (file) {
        if (!fnIsLegacyWordDoc(file)) return true;

        const oComponent = this.opts?._reactComponent;
        if (!oComponent) return true;

        oComponent.handleLegacyWordImport(this, file);
        // O .doc convertido sera entregue novamente como .docx pelo metodo publico do plugin.
        // Cancelar aqui impede o Mammoth de tentar interpretar o binario legado.
        return false;
      },
      'word.afterImport': async function (html) {
        const editor = this;

        try {
          editor.edit.off(); // trava enquanto sobe imagens

          const newHtml = await editor.opts._reactComponent
            .replaceBase64ImagesWithUploadedUrls(editor, html);

          editor.html.set(newHtml);
        } catch (e) {
          console.warn("word.afterImport: erro ao substituir imagens:", e);
        } finally {
          editor.edit.on(); // libera
        }
      },
      'word.beforeExport': function (editorHtml) {
        console.log('[word.beforeExport] len:', (editorHtml || '').length);

        // garante conteúdo (caso o parâmetro venha vazio em algum fluxo)
        const html = (editorHtml && editorHtml.trim()) ? editorHtml : this.html.get();
        // IMPORTANTE: devolver HTML COMPLETO
        return `
          <!doctype html>
          <html>
            <head>
              <meta charset="utf-8" />
            </head>
            <body>
              ${html}
            </body>
          </html>
        `;
      },

      'word.afterExport': function (exportedHtml) {
        this.html.set(exportedHtml);
        console.log('[word.beafterExport] HTML:', exportedHtml);
      },
      /*
        "word.beforeExport": function (editorHtml) {
          // Exemplo: rodapé no Word
          editorHtml += "<p style='font-size:10px;color:#888'>Exportado pelo Acredite.se</p>";
          return editorHtml;
        },

        "word.afterExport": function (editorHtml) {
          console.log("Exportação finalizada");
        }
      */
      "image.beforeRemove": function (img) {
        try {
          if (!img || typeof img.attr !== "function") return;

          const imageUrl = img.attr("src");
          if (!imageUrl) return;

          const cPath = imageUrl.replace(`${url.cBase}`, "");
          Axios.delete(cPath).catch(err => console.warn("Erro ao deletar imagem:", err));
        } catch (error) {
          console.warn("Erro no image.beforeRemove:", error);
        }
      },

      "video.beforeRemove": function (video) {
        try {
          if (!video || !video[0] || !video[0].firstChild) return;

          const videoElement = video[0].firstChild;
          const videoUrl = videoElement ? videoElement.currentSrc : null;
          if (!videoUrl) return;

          const cPath = videoUrl.replace(`${url.cBase}`, "");
          Axios.delete(cPath).catch(err => console.warn("Erro ao deletar vídeo:", err));
        } catch (error) {
          console.warn("Erro no video.beforeRemove:", error);
        }
      }
    };

    // Licença
    config.key = process.env.REACT_APP_FROALA_LICENSE_KEY;

    // =========================
    // Config por modo
    // =========================
    if (bRevisor) {
      config.imageEditable = false;
      config.imageResize = false;
      config.imageMove = false;
      config.imageDefaultAlign = "center";
      config.imageDefaultDisplay = "block";
      config.imageEditButtons = [];

      config.tableResizable = false;
      config.tableResize = false;
      config.tableDrag = false;
      config.dragInline = false;
      config.quickInsertEnabled = false;
      config.tableInsertHelper = false;
      config.enableTableSelection = false;

      config.toolbarButtons = {};
      config.trackChangesEnabled = true;

      config.listAdvancedTypes = false;
      config.imageUpload = false;
      config.videoUpload = false;
      config.fileUpload = false;
      config.linkAlwaysBlank = true;
      config.linkEditButtons = [];

    } else if (bReadOnly) {
      config.listAdvancedTypes = false;
      config.toolbarButtons = [];
      config.attribution = false;
      config.wordCounter = false;
      config.charCounterCount = false;

    } else if (bSimpleEditor) {
      config.listAdvancedTypes = false;
      config.toolbarBottom = true;

      if (cTypeComment === "X") {
        config.height = 200;
        config.toolbarButtons = {
          moreText: { buttons: ["bold", "italic", "underline"], align: "left" },
          moreParagraph: {
            buttons: ["paragraphFormat", "fontFamily", "formatOL", "formatUL", "alignLeft", "alignCenter", "alignRight", "alignJustify", "quote"],
            align: "left"
          },
          moreInsert: {
            buttons: ["insertLink", "insertImage", "insertVideo", "import_from_word"],
            align: "left",
            buttonsVisible: 5
          },
          moreTable: {
            buttons: ["insertTable", "tableRemove", "insertRowBefore", "insertRowAfter", "deleteRow", "insertColumnBefore", "insertColumnAfter", "deleteColumn", "mergeCells"],
            align: "left"
          },
          moreGPT: { buttons: ["chatGPT"], align: "left" },
          moreMisc: { buttons: ["fullscreen"], align: "right" }
        };
        config.toolbarButtonsMD = config.toolbarButtons;
        config.toolbarButtonsSM = config.toolbarButtons;
        config.toolbarButtonsXS = config.toolbarButtons;
      } else {
        config.toolbarButtons = {
          moreText: { buttons: ["bold", "italic", "underline"], align: "left" },
          moreParagraph: {
            buttons: ["paragraphFormat", "fontFamily", "formatOL", "formatUL", "alignLeft", "alignCenter", "alignRight", "alignJustify", "quote"],
            align: "left",
            buttonsVisible: 1
          },
          moreRich: {
            buttons: ["insertLink", "insertImage", "insertVideo", "import_from_word"],
            align: "left",
            buttonsVisible: 5
          },
          moreMisc: { buttons: ["chatGPT", "fullscreen"], align: "left" }
        };
        config.toolbarButtonsMD = config.toolbarButtons;
        config.toolbarButtonsSM = config.toolbarButtons;
        config.toolbarButtonsXS = config.toolbarButtons;
      }

    } else {
      config.listAdvancedTypes = true;
      const toolbar = [
         "chatGPT",
         "undo", "redo",
         "fullscreen",
         "bold", "italic", "underline",
         "textColor", "backgroundColor", "clearFormatting",
         "alignLeft", "alignCenter", "alignRight", "alignJustify",
         "formatOL", "formatUL",
         "indent", "outdent",
         "lineHeight","paragraphStyle","paragraphFormat", "fontFamily", "fontSize",
         "insertLink", "insertImage", "insertVideo",
         "insertTable",
         "import_from_word","export_to_word","selectAll","quote","specialCharacters","insertHR",
         "help",
         "html"
       ];

       config.toolbarButtons = toolbar;
       config.toolbarButtonsMD = toolbar;
       config.toolbarButtonsSM = toolbar;
       config.toolbarButtonsXS = toolbar;
    }

    return (
      <div>
        <FroalaEditor
          ref={elRef => { this.editorRef = elRef; }}
          model={model}
          onModelChange={evt => {
            if (this.bIsMounted) {
              this.handleModelChange(evt);
              if (typeof fnHandleChange === "function") fnHandleChange(evt);
            }
          }}
          config={config}
          typingTimer={1000}
        />

        {cErrorModalMsg && (
          <SweetAlert
            error
            title=""
            onCancel={this.hideAlert}
            onConfirm={this.hideAlert}
            closeOnClickOutside
            allowEscape
            showConfirm
          >
            {cErrorModalMsg}
          </SweetAlert>
        )}

        {(!cErrorModalMsg && alertMessage && !bHasGptKey) && (
          <GptModal
            bHasGptKey={bHasGptKey}
            fnOnClose={this.hideAlert}
            fnOnSave={this.saveApiKey}
            cMessage={alertMessage}
          />
        )}

        {(isLoading || isImportingWordImages || isConvertingWordDocument) && (
        <div style={styles.overlay}>
          <div style={styles.card}>
            <div style={styles.row}>
              <img src={fLoading} alt="Carregando..." style={styles.spinner} />

              <div style={{ flex: 1 }}>
                <div style={styles.title}>
                {isConvertingWordDocument
                  ? intl.get("DocumentEditor.conversion_in_progress")
                  : isImportingWordImages
                  ? intl.get("DocumentEditor.word_import_title")
                  : intl.get("loading")}
                </div>

                {isImportingWordImages && (
                  <div style={styles.subtitle}>
                    {intl.get("DocumentEditor.word_import_subtitle", { done: importDone, total: importTotal })}
                    {importError > 0
                      ? ` • ${intl.get("DocumentEditor.word_import_failures", { count: importError })}`
                      : ""}
                  </div>
                )}
              </div>

              {isImportingWordImages && (
                <div style={styles.badge}>
                  {Math.min(100, Math.round(((importDone || 0) / Math.max(importTotal || 1, 1)) * 100))}%
                </div>
              )}
            </div>

            {isImportingWordImages && (
              <div style={styles.progressWrap}>
                <div
                  style={{
                    ...styles.progressBar,
                    width: `${Math.min(
                      100,
                      Math.round(((importDone || 0) / Math.max(importTotal || 1, 1)) * 100)
                    )}%`,
                  }}
                />
              </div>
            )}

            {isImportingWordImages && importTotal > 0 && (
              <div style={styles.hint}>
                {intl.get("DocumentEditor.word_import_hint")}
              </div>
            )}
          </div>
        </div>
      )}
      </div>
    );
  }

}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.55)",
    backdropFilter: "blur(2px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999999,
    padding: 16,
  },
  card: {
    width: "min(520px, 92vw)",
    background: "rgba(20,20,24,0.96)",
    border: "1px solid rgba(255,255,255,0.10)",
    borderRadius: 14,
    boxShadow: "0 12px 40px rgba(0,0,0,0.45)",
    padding: 16,
    color: "#fff",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  spinner: {
    width: 42,
    height: 42,
    borderRadius: 8,
    background: "rgba(255,255,255,0.06)",
    padding: 6,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "20px",
  },
  subtitle: {
    marginTop: 4,
    fontSize: 13,
    opacity: 0.85,
  },
  badge: {
    fontSize: 12,
    fontWeight: 700,
    padding: "6px 10px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.10)",
    border: "1px solid rgba(255,255,255,0.12)",
  },
  progressWrap: {
    marginTop: 12,
    height: 10,
    borderRadius: 999,
    background: "rgba(255,255,255,0.10)",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    borderRadius: 999,
    background: "rgba(255,255,255,0.85)",
    transition: "width 180ms ease",
  },
  hint: {
    marginTop: 10,
    fontSize: 12,
    opacity: 0.75,
  },
};

FroalaEditorComponent.defaultProps = {
  config: {
    useClasses: true,
    attribution: false
  },
  model: null,
  elEditor: null,
  fnRef: null,
  bReadOnly: false,
  bRevisor: false, // Nova propriedade
};

class GptModal extends Component {
  constructor(oProps) {
    super(oProps);
    this.state = {
      cApiKey: '',
      bHasApiKey: oProps.bHasApiKey,
      bIsSending: false,
      cAlertMsg: ''
    }
    this.hideAlert = this.hideAlert.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSave = this.onSave.bind(this);
    this.handleApiKeyChange = this.handleApiKeyChange.bind(this);
  }

  hideAlert = () => {
    this.setState({ cAlertMsg: '' });
  }

  onClose = () => {
    const { fnOnClose } = this.props;
    fnOnClose();
  }

  handleApiKeyChange = (evtChange) => {
    this.setState({ cApiKey: evtChange.target.value });
  }

  onSave = async () => {
    const { cApiKey, bIsSending } = this.state;
    const { fnOnSave } = this.props;

    if (bIsSending) return;
    this.setState({ bIsSending: true });

    try {
      await Axios.patch("/customer/update-api-key", {
        cust_ckeyapigpt: JSON.stringify({ cApiKey })
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('cStorageToken')}`,
        },
      });

      localStorage.setItem('cApiGpt', '1');

      this.setState({
        cAlertMsg: '',
        bHasApiKey: true,
        bIsSending: false,
      });

      fnOnSave(cApiKey);
      this.onClose();

    } catch (oError) {
      const cAlertMsg = oError.response?.data?.cError ??
        "Erro desconhecido ao salvar a chave da API";
      this.setState({
        cApiKey: '',
        bHasApiKey: localStorage.getItem('cApiGpt') === '1',
        cAlertMsg,
        bIsSending: false,
      });
    }
  };

  render() {
    const { cMessage } = this.props;
    const { cAlertMsg, bIsSending, cApiKey } = this.state;

    return (
      <SweetAlert
        customClass="modal-edit md ScrollBar"
        title=""
        onCancel={this.onClose}
        onConfirm={this.onClose}
        showConfirm={false}
        closeOnClickOutside
        allowEscape
      >
        <div className="head-modal" style={{ marginTop: '-38px' }}>
          {intl.get('ChatGpt.titulo_api')}
          <span
            role="button"
            tabIndex="0"
            aria-labelledby="head-modal"
            onKeyPress={this.onClose}
            onClick={this.onClose}
            className="close"
            href=""
          />
        </div>
        {cAlertMsg && (
          <Alert type="error" message={cAlertMsg} onCloseAlert={this.hideAlert}>
            {cAlertMsg}
          </Alert>
        )}
        {cMessage}
        <div>
          <br />
          <input
            type="text"
            className="form form-control"
            style={{
              display: 'block',
              width: '100%',
              height: '40px',
              padding: '0 15px',
              border: '1px solid #ccc',
              borderRadius: '3px',
              marginTop: '5px',
              backgroundColor: '#fff',
              fontSize: '16px',
              fontFamily: '"Source Sans Pro", Helvetica, Arial, sans-serif',
              color: '#777',
              backgroundColor: '#fff',
              transition: 'all 200ms'
            }}
            onChange={this.handleApiKeyChange}
            value={cApiKey}
            placeholder="Digite a chave da API"
          />
          <br />
        </div>
        <div>
          <Button variant="success" href="https://platform.openai.com/api-keys" target='_blank'>{intl.get('ChatGpt.obter_chave')}</Button>
          <Button variant="info" href="https://openai.com/pricing" target='_blank'>{intl.get('ChatGpt.ver_planos')}</Button>
          <Button variant="primary" disabled={bIsSending} onClick={this.onSave}>{intl.get('ChatGpt.salvar_api')}</Button>
        </div>
      </SweetAlert>
    );
  }
}
